import HeadercourseModule from './containers/headercourseModule'

export {default as HeadercourseModuleLayout} from './components/headercourseModuleLayout'

export default HeadercourseModule
